import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";



function CleaningSwapDeal() {
  const { id } = useParams(); // DEAL ID
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");

  const [deal, setDeal] = useState(null);
  const [listingA, setListingA] = useState(null);
  const [listingB, setListingB] = useState(null);
  const [initiator, setInitiator] = useState(null);
const [receiver, setReceiver] = useState(null);


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [confirming, setConfirming] = useState(false);

  /* ======================================
     LOAD CLEANING SWAP DEAL
  ====================================== */
  useEffect(() => {
    async function loadDeal() {
      try {
        setLoading(true);
        setError("");

        const res = await axios.get(
          `${API_BASE_URL}/api/cleaning/swaps/deal/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!res.data?.success) {
          setError("Deal not found");
          return;
        }

        setDeal(res.data.deal);
        setListingA(res.data.listingA);
        setListingB(res.data.listingB);
        setInitiator(res.data.initiator);
setReceiver(res.data.receiver);

      } catch (err) {
        console.error("❌ Failed to load cleaning swap deal:", err);
        setError("Deal not found");
      } finally {
        setLoading(false);
      }
    }

    loadDeal();
  }, [id, token]);

  /* ======================================
     CONFIRM HANDOVER
  ====================================== */
  const confirmHandover = async () => {
    try {
      setConfirming(true);

      const res = await axios.post(
        `${API_BASE_URL}/api/cleaning/swaps/confirm-handover/${deal.id}`,
        { userId: user.id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!res.data?.success) {
        alert(res.data?.message || "Failed to confirm handover");
        return;
      }

      if (res.data.finished) {
        alert("✅ Handover completed successfully!");
      } else {
        alert("⏳ Your handover has been confirmed. Waiting for the other user.");
      }

      // Reload deal + listings
      const refreshed = await axios.get(
       `${API_BASE_URL}/api/cleaning/swaps/deal/${deal.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (refreshed.data?.success) {
        setDeal(refreshed.data.deal);
        setListingA(refreshed.data.listingA);
        setListingB(refreshed.data.listingB);
      setInitiator(refreshed.data.initiator);
setReceiver(refreshed.data.receiver);

      }
    } catch (err) {
      console.error("❌ Handover confirm failed:", err);
      alert("❌ Failed to confirm handover");
    } finally {
      setConfirming(false);
    }
  };

  /* ======================================
     STATES
  ====================================== */
  if (loading) {
    return <p style={{ padding: 30 }}>Loading swap deal…</p>;
  }

  if (error || !deal) {
    return <p style={{ padding: 30, color: "red" }}>{error}</p>;
  }

  const isUserA = user.id === deal.initiatorId;
  const isUserB = user.id === deal.receiverId;

  // ✅ MATCH POOL CARE PAYMENT LOGIC
const isInitiator = user.id === deal.initiatorId;

const userPaid =
  (isInitiator && deal.paymentA === 1) ||
  (!isInitiator && deal.paymentB === 1);

const otherPaid =
  (isInitiator && deal.paymentB === 1) ||
  (!isInitiator && deal.paymentA === 1);

const showPayButton =
  deal.swap_status === "payment_required" && !userPaid;


  const userConfirmed =
    (isUserA && deal.confirmA === 1) ||
    (isUserB && deal.confirmB === 1);

  const bothConfirmed = deal.confirmA === 1 && deal.confirmB === 1;

  const canRevealDetails =
    deal.swap_status === "handover" ||
    deal.swap_status === "completed";

    const canShowPartner =
  canRevealDetails && initiator && receiver;


  const canHandover = deal.swap_status === "handover";

  /* ======================================
     RENDER
  ====================================== */
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h2 style={{ color: "#2e7d32" }}>🧼 Cleaning Swap Deal</h2>

      {/* STATUS */}
      <div style={box}>
        <h3>Swap Status</h3>
<p style={{ fontWeight: "bold" }}>
  {bothConfirmed
    ? "Handover completed"
    : userPaid && otherPaid
    ? "Both users have paid. Confirm handover"
    : userPaid && !otherPaid
    ? "Waiting for the other user to pay"
    : "Payment required to proceed"}
</p>

        {bothConfirmed && (
          <div style={successBox}>
            ✔ Both users have confirmed<br />
            🎉 Handover completed!
          </div>
        )}
      </div>

      

   {/* PAYMENT */}
{showPayButton && (
  <div style={box}>
    <h3>💳 Payment Required</h3>

    <p>
      You must pay the cleaning swap fee to continue.
    </p>

    <button
      style={confirmBtn}
      onClick={async () => {
        try {
          const res = await axios.post(
            `${API_BASE_URL}/api/cleaning/swap-payments/pay`,
            { dealId: deal.id },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (res.data?.url) {
            window.location.href = res.data.url;
          }
        } catch (err) {
          console.error("❌ Cleaning swap payment error:", err);
          alert("❌ Payment failed to start");
        }
      }}
    >
      Pay Swap Fee
    </button>
  </div>
)}




      {/* DEAL INFO */}
      <div style={box}>
        <h3>Swap Deal Information</h3>
        <p><strong>Deal ID:</strong> {deal.id}</p>
        <p><strong>Swap Reference:</strong> {deal.swap_reference}</p>
        <p><strong>Listing A:</strong> {deal.listingId}</p>
        <p><strong>Listing B:</strong> {deal.offeredListingId}</p>
      </div>

{/* CLIENT DETAILS */}
<div style={box}>
  <h3>Client Details</h3>

  {canRevealDetails ? (
    <div style={clientGrid}>
      {listingA && (
        <div style={clientCard}>
          <h4 style={clientTitle}>Listing A</h4>

          <p>
            <strong>From:</strong> {listingA.swap_from_suburb}
          </p>

          <p>
            <strong>To:</strong> {listingA.swap_to_suburb}
          </p>
        </div>
      )}

      {listingB && (
        <div style={clientCard}>
          <h4 style={clientTitle}>Listing B</h4>

          <p>
            <strong>From:</strong> {listingB.swap_from_suburb}
          </p>

          <p>
            <strong>To:</strong> {listingB.swap_to_suburb}
          </p>
        </div>
      )}
    </div>
  ) : (
    <p style={{ opacity: 0.6 }}>
      🔒 Client details will be revealed once both parties have paid.
    </p>
  )}
</div>

      {/* SWAP PARTNER */}
<div style={box}>
  <h3>Swap Partner</h3>

  {canShowPartner ? (
    <p>
      <strong>Name:</strong>{" "}
      {isInitiator
        ? `${receiver.first_name} ${receiver.last_name}`
        : `${initiator.first_name} ${initiator.last_name}`}
      <br />

      <strong>Company:</strong>{" "}
      {isInitiator ? receiver.company : initiator.company}
      <br />

      <strong>Email:</strong>{" "}
      {isInitiator ? receiver.email : initiator.email}
      <br />

      <strong>Phone:</strong>{" "}
{isInitiator ? receiver.phone : initiator.phone}
<br />

      <strong>ABN:</strong>{" "}
      {isInitiator ? receiver.abn : initiator.abn}
    </p>
  ) : (
    <p style={{ opacity: 0.6 }}>
      🔒 Swap partner details will be revealed once both parties have paid.
    </p>
  )}
</div>




      {/* HANDOVER */}
      {canHandover && !bothConfirmed && (
        <div style={box}>
          <h3>Handover Confirmation</h3>

          {userConfirmed ? (
            <p style={{ color: "#2e7d32", fontWeight: "bold" }}>
              ✔ You have confirmed handover
            </p>
          ) : (
            <button
              onClick={confirmHandover}
              disabled={confirming}
              style={confirmBtn}
            >
              {confirming ? "Confirming…" : "Confirm Handover"}
            </button>
          )}
        </div>
      )}

      <button
        onClick={() => navigate(-1)}
        style={backBtn}
      >
        ← Back to My Swap Deals
      </button>
    </div>
  );
}


/* ================= STYLES ================= */

const box = {
  background: "#fff",
  padding: 20,
  marginTop: 20,
  borderRadius: 10,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

const successBox = {
  marginTop: 10,
  padding: 12,
  background: "#e8f5e9",
  borderRadius: 8,
  color: "#2e7d32",
  fontWeight: "bold",
};

const confirmBtn = {
  width: "100%",
  padding: 14,
  background: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontWeight: "bold",
  cursor: "pointer",
};

const backBtn = {
  marginTop: 30,
  padding: "12px 16px",
  background: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const clientGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16,
  marginTop: 12,
};

const clientCard = {
  background: "#f8faf8",
  border: "1px solid #e1e8e1",
  borderRadius: 10,
  padding: 16,
};

const clientTitle = {
  marginTop: 0,
  marginBottom: 10,
  color: "#2e7d32",
};

export default CleaningSwapDeal;
